module.exports = __webpack_public_path__ + "static/media/piano_annuale_preparazione_sci.56918a8c.jpg";